import React from 'react';
import { InputType, useFormContext } from '../../molecules/Form';
import FormsRow from '../../molecules/Form/components/FormsRow/FormsRow';
import FormsColumn from '../../molecules/Form/components/FormsColumn/FormsColumn';
import FormSelect, { optionsProcessor } from '../../molecules/Form/components/FormSelect/FormSelect';
import { createFormElement } from '../../molecules/Form/FormFactory';
import LiveRegion from '../../atoms/LiveRegion/LiveRegion';
import FormInput from '../../molecules/Form/components/FormInput/FormInput';
import { ListBoxModifier, UserSingleSelectComboBox } from '../../molecules/Form/components/ComboBox';
import { FormSubmitButton } from '../../molecules/Form/components/FormSubmitButton/FormSubmitButton';
import { RequiredHelpPhrase } from '../../../_lib/Form2';

type UserInviteFormTemplateType = {
  id: string;
  headline?: string;
  statusMessages: any;
  error?: string;
  userMail?: {
    label: string;
    helpText: string;
    patternMismatchErrorMessage: string;
  };
  userSelect?: {
    label: string;
    helpText: string;
    validationMessage: string;
  };
  roleSelect: {
    label: string;
    translationNamespace?: string;
  };
  message: {
    label: string;
  };
  submit: {
    name: string;
  };
};

export default function UserInviteFormTemplate({
  statusMessages,
  error,
  id,
  headline,
  userMail,
  userSelect,
  roleSelect,
  message,
  submit,
}: UserInviteFormTemplateType) {
  const { inputs, onChange, getStatus, submitActionEnabled } = useFormContext();

  /**
   * FormInput > invite_unregistered
   * FormsComboBox > invite
   * switch only according to inputs of form model
   * */
  const getUserChooser = () => {
    if (inputs.email && !inputs.recipientId && userMail) {
      return (
        <FormInput
          type={InputType.EMAIL}
          id="invite-unregistered"
          name={inputs.email.name}
          labelHelpText={userMail.helpText}
          labelTitle={userMail.label}
          required={inputs.email.required}
          onChange={(event: any) => onChange(inputs.email.name, event.target.value)}
          patternMismatchErrorMessage={userMail.patternMismatchErrorMessage}
          pattern={inputs.email.constraints?.pattern}
        />
      );
    }

    if (userSelect) {
      return (
        <UserSingleSelectComboBox
          id="combobox-user-invite"
          name="combobox-user-invite"
          helpText={userSelect.helpText}
          labelTitle={userSelect.label}
          validationMessage={userSelect.validationMessage}
          hiddenInputName={inputs.recipientId.name}
          required={inputs.recipientId.required || false}
          suggestUrl={inputs.recipientId.comboBoxUrl?.url as any}
          onChange={item => onChange(inputs.recipientId.name, item?.id)}
          modifierListBox={ListBoxModifier.RELATIVE}
        />
      );
    }

    return null;
  };

  return (
    <>
      {headline && <h3 className="form__headline">{headline}</h3>}
      <RequiredHelpPhrase />
      <FormsRow>
        <FormsColumn>{getUserChooser()}</FormsColumn>
        <FormsColumn>
          <FormSelect
            id={`select-${id}`}
            name="roleId"
            labelTitle={roleSelect.label}
            value={inputs.roleId.value}
            options={optionsProcessor(
              inputs.roleId.name,
              inputs.roleId.options as any,
              roleSelect.translationNamespace,
            )}
            required={inputs.roleId.required}
            // Events
            onChange={(event: any) => onChange(event.target.name, event.target.value)}
          />
        </FormsColumn>
      </FormsRow>
      {createFormElement()(inputs.invitationText, id, onChange, message.label)}
      <FormSubmitButton buttonLabel={submit.name} enabled={submitActionEnabled()} />
      <LiveRegion invisible={false} htmlTag="div">
        {getStatus(statusMessages, error, true)}
      </LiveRegion>
    </>
  );
}
